import { apiGetRequest } from '../../../../utils/api/get';
import { apiPostRequest } from '../../../../utils/api/post';
import {
  VendorCommissionListResponse,
  UpdateCommissionRequest,
  UpdateCommissionResponse,
} from '../../model/commission';
import { BASE_URL } from '../../../../utils/auth';

export const fetchVendorCommissionsAPI = (
  token: string
): Promise<VendorCommissionListResponse> =>
  apiGetRequest<VendorCommissionListResponse>({
    apiUrl: `${BASE_URL}/commission/vendors`,
    token,
  });

export const updateVendorCommissionAPI = (
  token: string,
  vendorId: number,
  data: UpdateCommissionRequest
): Promise<UpdateCommissionResponse> =>
  // PATCH is not in our utility, use POST-like fetch directly
  fetch(`${BASE_URL}/commission/vendor/${vendorId}`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  }).then(async (res) => {
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: 'Update failed.' }));
      return Promise.reject(err);
    }
    return res.json() as Promise<UpdateCommissionResponse>;
  });
